import PropTypes from 'prop-types';
import React, { Component } from 'react';
import './QuestionIcon.css';
import { UncontrolledTooltip } from 'reactstrap';
class QuestionIcon extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    tooltipInfo: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    this.id = props.id;
    this.tooltipInfo = props.tooltipInfo;
  }

  render() {
    return (
      <div>
        <i
          className="questionIconComponent togo-icon togo-icon-question-circle questionIcon"
          id={`toolTipMoreInfoText${this.props.id}`}
        />
        <UncontrolledTooltip
          placement="right"
          target={`toolTipMoreInfoText${this.props.id}`}
          className="tooltip-white"
          innerClassName="tooltipInner">
          {this.props.tooltipInfo}
        </UncontrolledTooltip>
      </div>
    );
  }
}

export default QuestionIcon;



// WEBPACK FOOTER //
// ./src/Components/QuestionIcon/QuestionIcon.js